export const META_STORAGE_NAME = 'net.kauz.ng.meta';
export const DEFAULT_LANGUAGE = 'DE';
export const FALLBACK_LANGUAGE = 'EN';
